import { manufacturingFetch } from "@/lib/manufacturingClient";
import type {
  MfgMaterialAliasDeleteResponse,
  MfgMaterialAliasesListResponse,
  MfgMaterialAliasUpsertResponse,
} from "@/lib/manufacturing/types";

export function listManufacturingMaterialAliases(opts?: { material_id?: string }) {
  const q = new URLSearchParams();
  if (opts?.material_id) q.set("material_id", opts.material_id);
  const qs = q.toString();
  return manufacturingFetch<MfgMaterialAliasesListResponse>(
    qs ? `/api/mfg/material-aliases?${qs}` : "/api/mfg/material-aliases",
    { method: "GET" }
  );
}

export function upsertManufacturingMaterialAlias(payload: {
  id?: string;
  material_id: string;
  vendor_name: string;
  vendor_sku: string;
  vendor_description?: string;
  unit_conversion_factor?: number;
  last_observed_unit_cost?: number | null;
  notes?: string;
}) {
  return manufacturingFetch<MfgMaterialAliasUpsertResponse>("/api/mfg/material-aliases/upsert", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export function deleteManufacturingMaterialAlias(payload: { alias_id: string }) {
  return manufacturingFetch<MfgMaterialAliasDeleteResponse>("/api/mfg/material-aliases/delete", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
